
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function withAuth(Component) {
  return function AuthenticatedComponent(props) {
    const navigate = useNavigate();

    useEffect(() => {
      const readSession = (key) => {
        try {
          const value = JSON.parse(localStorage.getItem(key) || 'null');
          return value && typeof value === 'object' ? value : null;
        } catch (error) {
          return null;
        }
      };
      const center = readSession('centerdata');
      const tl = readSession('tldata');
      const validCenter = Number(center?.center_id || 0) > 0 && center?.login_type === 'center';
      const validTl = Number(tl?.center_mis_id || 0) > 0 && Number(tl?.centerid || 0) > 0 && tl?.login_type === 'tl';

      if (!validCenter && !validTl) {
        localStorage.removeItem('centerdata');
        localStorage.removeItem('tldata');
        navigate('/'); 
      }
    }, [navigate]);

    return <Component {...props} />;
  };
}
